export const styles = {
  headerFont: "'Faustina', serif",
  bodyFont: "'Montserrat', serif",
  mediumScreen: "768px",
  smallScreen: "500px",
}
